import QS from 'qs'
import QRCode from 'qrcode'
import Cookies from 'js-cookie'
import { isToBApp } from 'base/config'
import { URL_PARAM } from '@/utils/variables.js'

export async function drawCardImage(data, options = {}) {
  const { scene } = options
  const params = {
    nw: 1,
    uuid: data.uuid,
    theme: data.theme,
    cardUuid: data.cardUuid,
    coverId: data.coverId
  }
  if ([2, 4].includes(scene)) {
    params.familyId = URL_PARAM.familyId
    if (isToBApp) {
      params.app = Cookies.get('appId')
    }
  }

  const qrUrl = `${location.origin}${location.pathname}?${QS.stringify(params)}`
  const qrImage = await QRCode.toDataURL(qrUrl, { margin: 0 })
  const promises = [data.photo, qrImage].filter(e => !!e).map(url => {
    return new Promise((resolve) => {
      const image = new Image()
      image.crossOrigin = 'anonymous'
      image.src = url
      image.onload = (img) => {
        const width = img.target.width
        const height = img.target.height
        resolve({
          image,
          width,
          height
        })
      }
    })
  })

  return Promise.all(promises).then(results => {
    const canvas = document.createElement('canvas')
    canvas.width   = options.width || 750
    const fontSize = options.fontSize || 24
    const padding  = options.padding || 30
    const imageWidth = fontSize * 6.25
    const lineHeight = fontSize * 1.35
    canvas.height = imageWidth + padding * 2

    const ctx = canvas.getContext('2d')

    ctx.save();
    drawRoundRect(ctx, padding / 2, padding, imageWidth, imageWidth, imageWidth / 2);
    ctx.clip();
    if (results[0]) {
      ctx.drawImage(results[0].image, padding / 2, padding, imageWidth, imageWidth)
    }
    ctx.restore();

    if (results[1]) {
      ctx.drawImage(results[1].image, canvas.width / 2 + padding / 2, padding, imageWidth, imageWidth)
    }

    ctx.fillStyle = '#666666';

    ctx.save();
    ctx.fillStyle = '#333333';
    ctx.font = `normal normal bold ${fontSize}px Arial`;
    ctx.fontWeight = 'bold'
    ctx.fillText(data.name, imageWidth + padding, canvas.height / 2);
    ctx.restore()

    ctx.save();
    ctx.font = `normal normal normal ${fontSize}px Arial`;
    ctx.fillText(data.telephone, imageWidth + padding, canvas.height / 2 + lineHeight);
    ctx.restore()

    const supplementalTx = data.photo ? '并以保单为准！' : ''
    ctx.save();
    ctx.font = `normal normal normal ${fontSize * 0.8571}px Arial`;

    if (supplementalTx) {
      ctx.fillText('请识别二维码查看', canvas.width / 2 + imageWidth + padding, canvas.height / 2);
      ctx.fillText(supplementalTx, canvas.width / 2 + imageWidth + padding, canvas.height / 2 + lineHeight);
    } else {
      ctx.fillText('请识别二维码查看', canvas.width / 2 + imageWidth + padding, canvas.height / 2);
    }
    ctx.restore()

    // document.body.append(canvas)
    return canvas.toDataURL()
  })
}

function drawRoundRect(ctx, x, y, w, h, r) {
  const min_size = Math.min(w, h);
  if (r > min_size / 2) {
    r = min_size / 2;
  }
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

export function mergeImagesByCanvas(imgs) {
  if (!imgs) {
    return null
  }
  if (imgs.length === 1) {
  	return imgs[0]
  }
  const promises = imgs.map(url => {
    return new Promise((resolve, reject) => {
      const image = new Image()
      image.src = url
      image.crossOrigin = 'anonymous'
      image.onload = (img) => {
        resolve({
          image,
          width: img.target.width,
          height: img.target.height
        })
      }
    })
  })
  return Promise.all(promises).then(results => {
    const canvas = document.createElement('canvas')
    canvas.width = Math.max.apply(Math, results.map(img => img.width))
    canvas.height = results.reduce((accumulate, img) => accumulate + img.height, 0)
    const ctx = canvas.getContext('2d')
    ctx.fillStyle = '#fff'
    ctx.fillRect(0, 0, canvas.width, canvas.height)

    let y = 0
    results.forEach((img, i) => {
      const x = (canvas.width - img.width) / 2
      if (i === 1) {
        ctx.fillStyle = '#f2f2f2'
        ctx.fillRect(0, y, canvas.width, img.height)
      }
      ctx.drawImage(img.image, x, y, img.width, img.height)
      y += img.height
    })
    return canvas.toDataURL()
  })
}

export function showImageViewer(dataURL) {
  const hasShowImageViewer = window.appBridge && window.appBridge.checkAppFeature('NATIVE_IMAGE_VIEWER')
  if (!dataURL || !hasShowImageViewer) {
    return
  }
  window.WeiyiStatSDK.submit('SLT')
  appBridge
    .showImageViewer({
      urls: [dataURL]
    })
    .catch(function (e) {
      console.log('toast', e.name + '  ' + e.message)
    })
}